module.exports = __webpack_public_path__ + "static/img/022_TO8_1508_og.a8f43e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/022_TO8_1508_og.jpg
// module id = vxNz
// module chunks = 0